var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-bar"},[_c('ul',{staticClass:"left-bar-ul"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"span-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"bg-title"})]),_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:{
        'top-radius': index == 0,
        'bottom-radius': index == _vm.list.length - 1,
        'bar-cell':index !=_vm.currentMenuIndex,
        'check-bar-cell':index ==_vm.currentMenuIndex,
      },on:{"click":function($event){return _vm.handleClickMenu(item,index)}}},[_vm._v(" "+_vm._s(item)+" ")])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }